// 戴冠獣の足元を「歩いている時だけ」持ち上げる (2026-11-03・駅7 #4 の続き)。配布版の既定は入 (11-03 作者 答えるページ KPBLJRA2EbH18gsZEnHkFi choice=ok)。
//   前の版 (持ち上げ 0・絵の下端が床より約12px 下) は開発版 `?houndLift=old`。
//   作者 (11-03 答えるページ): 「12px 上げると技を打ったときとかに空中に浮いてる／技の時が問題なのかも？／だとしたら歩いてるときは 12px の方が良い」。
//   = 待機・歩き (boss.state === 'idle') は 12px 上げ、技 (予備動作・振り・隙・連撃の間・崩れ) は今の 0。
//   切り替わりで足元が一瞬で 12px 跳ねないよう、持ち上げ量を時間で寄せる (時定数 LIFT_TAU_S)。
//   記録 = docs/research/2026-11-03-hound-walk-lift-and-two-frame-walk.md
import type { Boss } from './types'

export const HOUND_WALK_LIFT_PX = 12
export const LIFT_TAU_S = 0.1

let enabled = true
let cur: { lift: number; time: number } | null = null

export function setHoundWalkLift(v: string | null): void {
  enabled = v !== 'old'
  cur = null
}

export function houndWalkLiftEnabled(): boolean {
  return enabled
}

export function houndWalkLiftTarget(state: Boss['state']): number {
  return state === 'idle' ? HOUND_WALK_LIFT_PX : 0
}

// 1フレームに1回 (render の draw の頭) 呼ぶ。今の持ち上げ量を返し、bossFootY が読む。
export function stepHoundWalkLift(boss: Boss | null | undefined, time: number): number | null {
  if (!enabled || !boss || boss.id !== 'dream-hound') return null
  const target = houndWalkLiftTarget(boss.state)
  if (!cur || time < cur.time || time - cur.time > 0.5) cur = { lift: target, time }
  const dt = time - cur.time
  cur = { lift: cur.lift + (target - cur.lift) * (1 - Math.exp(-dt / LIFT_TAU_S)), time }
  return cur.lift
}

export function houndWalkLiftNow(bossId: string): number | null {
  return enabled && bossId === 'dream-hound' && cur ? cur.lift : null
}
